<template>
	<div
		class="error-empty-state"
		:class="{
			'error-empty-state--bordered': bordered,
			'error-empty-state--compact': compact,
		}"
	>
		<img
			:src="troubleshootingIcon"
			alt=""
			:width="iconSize"
			:height="iconSize"
		/>
		<span
			class="error-empty-state__title sgnl-text-color-default"
			:class="compact ? 'sgnl-paragraph-s-semibold' : 'sgnl-subtitle-semibold'"
		>
			{{ title }}
		</span>
		<div class="error-empty-state__body sgnl-text-color-secondary">
			<div :class="compact ? 'sgnl-caption-regular' : 'sgnl-paragraph-s-regular'">{{ message }}</div>
			<div
				v-if="!compact"
				class="sgnl-paragraph-s-regular error-empty-state__support"
			>
				If the issue persists, please contact support at
				<a
					class="error-empty-state__support-link sgnl-text-color-brand"
					href="mailto:developer-support@signaloid.com"
					>developer-support@signaloid.com</a
				>.
			</div>
		</div>
		<div class="error-empty-state__actions">
			<v-btn
				variant="flat"
				color="primary"
				:loading="retrying"
				@click="$emit('retry')"
			>
				Reload
			</v-btn>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import troubleshootingIcon from "@/assets/icons/common/troubleshooting-96.svg";

export default defineComponent({
	name: "ErrorEmptyState",
	props: {
		title: { type: String, required: true },
		message: { type: String, required: true },
		retrying: { type: Boolean, default: false },
		bordered: { type: Boolean, default: false },
		compact: { type: Boolean, default: false },
	},
	emits: ["retry"],
	setup() {
		return { troubleshootingIcon };
	},
	computed: {
		iconSize(): number {
			return this.compact ? 32 : 96;
		},
	},
});
</script>

<style scoped>
.error-empty-state {
	padding: var(--sgnl-space-24);
	display: flex;
	flex-direction: column;
	gap: var(--sgnl-space-16);
	align-items: center;
	text-align: center;
	max-width: 600px;
	margin: 0 auto;
	background: transparent;
}

.error-empty-state--compact {
	padding: var(--sgnl-space-16);
	gap: var(--sgnl-space-12);
}

.error-empty-state--bordered {
	border: var(--sgnl-border-width-1) solid var(--sgnl-default-primary-border);
	border-radius: var(--sgnl-border-radius-6);
	max-width: none;
}

.error-empty-state__title {
	max-width: 600px;
}

.error-empty-state__body {
	max-width: 600px;
	display: flex;
	flex-direction: column;
	gap: var(--sgnl-space-8);
}

.error-empty-state__actions {
	display: flex;
	justify-content: center;
	gap: var(--sgnl-space-8);
}

.error-empty-state__support-link {
	text-decoration: underline;
}

.error-empty-state__support-link:hover {
	color: var(--sgnl-brand-text-hover);
}
</style>
